import { Box, type BoxProps, Flex, HStack } from '@chakra-ui/react';

import { Logo } from '@/components';

import { NavBarLanguageMenu } from '../common';
import { INTERVIEW_NAV_BAR_HEIGHT } from '../interview/constants';

export const LegalNavBar = (props: BoxProps) => {
  return (
    <Box {...props}>
      <Flex
        zIndex="sticky"
        position="fixed"
        top="0"
        insetStart="0"
        insetEnd="0"
        color="gray.50"
        align="center"
        justify="center"
        pt="safe-top"
        px="4"
        h={INTERVIEW_NAV_BAR_HEIGHT}
        bg="white"
        boxShadow="layout"
        borderBottom="1px solid transparent"
      >
        <Flex
          grow={1}
          align="center"
          justify="space-between"
          maxW="container.xl"
        >
          <Box mx={0}>
            <Logo />
          </Box>

          <HStack>
            <NavBarLanguageMenu />
          </HStack>
        </Flex>
      </Flex>
      <Box h={INTERVIEW_NAV_BAR_HEIGHT} />
    </Box>
  );
};
